/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-678f6c80"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "content-list-wrap" };
const _hoisted_2 = { class: "item-wrap" };
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/SensitiveInput/index.vue"));
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const one_message_1 = require("@/utils/one_message");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PathPointPanel',
    props: {
        isOnDrag: {
            default: false
        }
    },
    setup(__props, { expose: __expose }) {
        const curRobot = computed(() => { var _a, _b; return (_b = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram) === null || _b === void 0 ? void 0 : _b.robot; });
        const store = (0, work_1.useWork)();
        const NAMES = [model_1.PathTypeName.route, model_1.PathTypeName.point, model_1.PathTypeName.joints, model_1.PathTypeName.jointPoint];
        const props = __props;
        const onSortEnd = (event) => {
            var _a, _b;
            const { oldIndex, newIndex } = event;
            const formPath = cfgPath.value[oldIndex];
            const toPath = cfgPath.value[newIndex];
            const toIndex = (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.paths.findIndex(path => path.id === toPath.id);
            (_b = curRobot.value) === null || _b === void 0 ? void 0 : _b.movePathElement(formPath.id, toIndex);
        };
        const cfgPath = computed(() => {
            var _a;
            return ((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.paths.filter(path => {
                if (path.type === 'route' && path.ioId == null) {
                    return true;
                }
                else if (path.type === 'point' && path.ioId == null) {
                    return true;
                }
                else if (['joints', 'jointPoint'].includes(path.type)) {
                    return true;
                }
                else {
                    return false;
                }
            })) || [];
        });
        function handleAddPath() {
            var _a, _b;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.addPath(NAMES[0], [[0, 0, 0, 0, 0, 0]], "route", null, true, undefined, (_b = curRobot.value) === null || _b === void 0 ? void 0 : _b.code.processGroups[0].id);
        }
        function handleAddPoint() {
            var _a, _b;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.addPath(NAMES[1], [[0, 0, 0, 0, 0, 0]], "point", null, true, undefined, (_b = curRobot.value) === null || _b === void 0 ? void 0 : _b.code.processGroups[0].id);
        }
        function handleAddJoints() {
            var _a, _b;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.addPath(NAMES[2], [[0, 0, 0, 0, 0, 0, 0, 0]], 'joints', null, true, undefined, (_b = curRobot.value) === null || _b === void 0 ? void 0 : _b.code.processGroups[0].id);
        }
        function handleAddJointPoint() {
            var _a, _b;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.addPath(NAMES[3], [[0, 0, 0, 0, 0, 0, 0, 0]], 'jointPoint', null, true, undefined, (_b = curRobot.value) === null || _b === void 0 ? void 0 : _b.code.processGroups[0].id);
        }
        function onChanged(item) {
            store.notifyChangeRoute(item);
        }
        function getSvgIcon(pathType) {
            switch (pathType) {
                case "point":
                    return 'program-pose';
                case "route":
                    return "program-route";
                case "jointPoint":
                    return "program-joint";
                case "joints":
                    return "program-joints";
                default:
                    return '';
            }
        }
        function onNameBeforeChange(name) {
            var _a;
            let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            if (patrn.test(name)) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有特殊字符，请重新修改！', type: 'error' });
                return false;
            }
            if (name.indexOf(' ') !== -1) {
                (0, one_message_1.oneMessage)({ message: '名称不能含有空格，请重新修改！', type: 'error' });
                return false;
            }
            if (name.length > 15) {
                (0, one_message_1.oneMessage)({ message: '名称不能超过15个字符！', type: 'error' });
                return false;
            }
            let paths = ((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.paths) || [];
            let isSameName = !!paths.find(path => path.name === name);
            if (isSameName) {
                (0, one_message_1.oneMessage)({ message: '名称重复，请重新修改！', type: 'error' });
            }
            return !isSameName;
        }
        function handleDel(element) {
            var _a;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.delPath(element.id);
            store.notifyDeleteRoute(element);
        }
        function handleNewPathPoint(typeName) {
            const reduceFunc = [handleAddPath, handleAddPoint, handleAddJoints, handleAddJointPoint];
            const reduceFuncIndex = NAMES.findIndex(item => item === typeName);
            if (reduceFuncIndex < 0 || reduceFuncIndex >= reduceFunc.length)
                throw new Error('type error');
            reduceFunc[reduceFuncIndex]();
        }
        __expose({
            NAMES,
            handleNewPathPoint
        });
        return (_ctx, _cache) => {
            const _component_Switch = (0, vue_2.resolveComponent)("Switch");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_svg_icon = (0, vue_2.resolveComponent)("svg-icon");
            const _component_el_option = (0, vue_2.resolveComponent)("el-option");
            const _component_el_select = (0, vue_2.resolveComponent)("el-select");
            const _component_el_checkbox = (0, vue_2.resolveComponent)("el-checkbox");
            const _component_draggable = (0, vue_2.resolveComponent)("draggable");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(_component_draggable, {
                        modelValue: (0, vue_2.unref)(cfgPath),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(cfgPath) ? (cfgPath).value = $event : null)),
                        onEnd: onSortEnd,
                        "item-key": "`cfgPath${id}`",
                        filter: ".item-wrap",
                        disabled: !__props.isOnDrag
                    }, {
                        item: (0, vue_2.withCtx)(({ element }) => [
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_icon, { class: "darg-icon" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_Switch)
                                    ]),
                                    _: 1
                                }, 512), [
                                    [vue_2.vShow, __props.isOnDrag]
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                    (0, vue_2.createVNode)(index_vue_2.default, {
                                        model: element.name,
                                        "onUpdate:model": ($event) => ((element.name) = $event),
                                        beforeChange: onNameBeforeChange,
                                        onOnChange: ($event) => (onChanged(element)),
                                        maxlength: 15
                                    }, {
                                        prefix: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_svg_icon, {
                                                "icon-class": getSvgIcon(element.type)
                                            }, null, 8, ["icon-class"])
                                        ]),
                                        _: 2
                                    }, 1032, ["model", "onUpdate:model", "onOnChange"]),
                                    (0, vue_2.createVNode)(_component_el_select, {
                                        modelValue: element.group,
                                        "onUpdate:modelValue": ($event) => ((element.group) = $event)
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(curRobot).code.processGroups, (group, index) => {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                                    key: `group${index}`,
                                                    label: group.name,
                                                    value: group.id
                                                }, null, 8, ["label", "value"]));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                    (0, vue_2.createVNode)(_component_el_checkbox, {
                                        size: "small",
                                        modelValue: element.isTeach,
                                        "onUpdate:modelValue": ($event) => ((element.isTeach) = $event)
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("示教")
                                        ]),
                                        _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                    (0, vue_2.createVNode)(index_vue_1.default, {
                                        title: `确认删除'${element.name}'吗？`,
                                        onDelConfirm: ($event) => (handleDel(element))
                                    }, null, 8, ["title", "onDelConfirm"])
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue", "disabled"])
                ])
            ]));
        };
    }
});
